import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import Footer from './components/Footer/Footer';
import AudioMNIST from './components/Projects/AudioMNIST/AudioMNIST';
import './App.css';
import EasyMarks from './components/Projects/EasyMarks/EasyMarks';
import PyTeen from './components/Projects/PyTeen/PyTeen';
import EDA from './components/Projects/EDA/EDA';
import RAG from './components/Projects/RAG/RAG';
import Connect from './components/Connect/Connect';
import Cards from './components/Cards/Cards';

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/projects" exact element={<Cards />} />
          <Route path="/audio-mnist" exact element={<AudioMNIST />} />
          <Route path="/easy-marks" exact element={<EasyMarks />} />
          <Route path="/pyteen" exact element={<PyTeen />} />
          <Route path="/eda" exact element={<EDA />} />
          <Route path="/RAG" exact element={<RAG />} />
          <Route path="/connect" exact element={<Connect />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
